/* eslint-disable array-callback-return */
import { useContext, useState, useEffect, useMemo } from "react";
import PrestacionContext from "../../../context/PrestacionesContext/PrestacionContext";
import { closeUserBenefitsModal } from "../../../context/PrestacionesContext/Actions";
import {
  Dialog,
  IconButton,
  Box,
  TextField,
  Button,
} from "@material-ui/core";

import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import "../css/AdminColaboradores.css";
import { ErrorAlert } from "../../../alerts/errorAlert";

const AdminColaboradoresPrestacion = ({
  users = [],
  userSelect = [],
  setSelectedUser,
  colaboradoresBD = [],
}: any) => {
  const { state, dispatch } = useContext(PrestacionContext);

  const [estadoInicial, setEstadoInicial] = useState<any[]>([]);
  const [seleccionadas, setSeleccionadas] = useState<any[]>([]);

  const [viewTxtFind, setViewTxtFind] = useState(true);
  const [viewTxtFindSelec, setViewTxtFindSelec] = useState(true);

  const [searchDisponibles, setSearchDisponibles] = useState("");
  const [searchSeleccionadas, setSearchSeleccionadas] = useState("");

  /* ===============================
     Inicialización limpia
  =============================== */

  useEffect(() => {
    if (!users.length) return;

    const idsBD = new Set(
      colaboradoresBD.map((c: any) => parseInt(c.idUsuario))
    );

    const seleccionDB = users.filter((u: any) =>
      idsBD.has(parseInt(u.id))
    );

    const seleccionManual = users.filter((u: any) =>
      userSelect.some((s: any) => s.id === u.id)
    );

    const seleccionTotal = [...new Map(
      [...seleccionDB, ...seleccionManual].map((item) => [item.id, item])
    ).values()];

    const disponibles = users.filter(
      (u: any) => !seleccionTotal.some((s) => s.id === u.id)
    );

    setSeleccionadas(seleccionTotal);
    setEstadoInicial(disponibles);
  }, [users, colaboradoresBD, userSelect]);

  /* ===============================
     Movimientos simples
  =============================== */

  const moverADerecha = (item: any) => {
    setSeleccionadas((prev) => [...prev, item]);
    setEstadoInicial((prev) => prev.filter((u) => u.id !== item.id));
  };

  const moverAIzquierda = (item: any) => {
    setEstadoInicial((prev) => [...prev, item]);
    setSeleccionadas((prev) => prev.filter((u) => u.id !== item.id));
  };

  const agregaTodas = () => {
    setSeleccionadas((prev) => [...prev, ...estadoInicial]);
    setEstadoInicial([]);
  };

  const eliminaTodas = () => {
    setEstadoInicial((prev) => [...prev, ...seleccionadas]);
    setSeleccionadas([]);
  };

  /* ===============================
     Filtros memoizados
  =============================== */

  const disponiblesFiltrados = useMemo(() => {
    return estadoInicial.filter((u: any) =>
      u.bussinesName
        ?.toUpperCase()
        .includes(searchDisponibles.toUpperCase())
    );
  }, [estadoInicial, searchDisponibles]);

  const seleccionadasFiltradas = useMemo(() => {
    return seleccionadas.filter((u: any) =>
      u.bussinesName
        ?.toUpperCase()
        .includes(searchSeleccionadas.toUpperCase())
    );
  }, [seleccionadas, searchSeleccionadas]);

  const filtrar = () => {
    setEstadoInicial((prev) =>
      [...prev].sort((a, b) =>
        a.bussinesName.localeCompare(b.bussinesName)
      )
    );
  };

  const filtrarSelec = () => {
    setSeleccionadas((prev) =>
      [...prev].sort((a, b) =>
        a.bussinesName.localeCompare(b.bussinesName)
      )
    );
  };

  /* ===============================
     Acciones finales
  =============================== */

  const cancelar = () => {
    setEstadoInicial([]);
    setSeleccionadas([]);
    closeUserBenefitsModal(dispatch);
  };

  const handleAddUser = () => {
    if (!seleccionadas.length) {
      ErrorAlert({ text: "Es necesario seleccionar a un colaborador" });
      return;
    }

    setSelectedUser(seleccionadas);
    cancelar();
  };

  /* ===============================
     UI (NO MODIFICADA)
  =============================== */

  return (
    <Dialog
      open={state.createModalUserBenefits}
      aria-labelledby="form-dialog-title"
      fullWidth={true}
    >
      <div className="dialogUser">
        <div>
          <div className="contenedorTitulosColumnas">
            {/* ================= IZQUIERDA ================= */}
            <div className="contenedorTituloUno">
              <span className="titulosColumnas">
                Todos los colaboradores disponibles
              </span>

              <div>
                {viewTxtFind ? (
                  <IconButton
                    size="small"
                    onClick={() => setViewTxtFind(false)}
                  >
                    <SearchIcon color="disabled" />
                  </IconButton>
                ) : (
                  <Box className="containerfind">
                    <TextField
                      label="Colaborador"
                      size="small"
                      variant="outlined"
                      onChange={(e) =>
                        setSearchDisponibles(e.target.value)
                      }
                    />
                    <IconButton
                      size="small"
                      onClick={() => setViewTxtFind(true)}
                    >
                      <SearchIcon color="disabled" />
                    </IconButton>
                  </Box>
                )}
              </div>

              <div className="btnFilter">
                <Button size="small" onClick={filtrar}>
                  <FilterListIcon fontSize="small" className="Filter" />{" "}
                  Filtrar
                </Button>
              </div>
            </div>

            {/* ================= DERECHA ================= */}
            <div className="contenedorTituloDos">
              <span className="titulosColumnas">
                Colaboradores incluidos en la prestación
              </span>

              <div>
                {viewTxtFindSelec ? (
                  <IconButton
                    size="small"
                    onClick={() => setViewTxtFindSelec(false)}
                  >
                    <SearchIcon color="disabled" />
                  </IconButton>
                ) : (
                  <Box className="containerfind">
                    <TextField
                      label="Colaborador"
                      size="small"
                      variant="outlined"
                      onChange={(e) =>
                        setSearchSeleccionadas(e.target.value)
                      }
                    />
                    <IconButton
                      size="small"
                      onClick={() => setViewTxtFindSelec(true)}
                    >
                      <SearchIcon color="disabled" />
                    </IconButton>
                  </Box>
                )}
              </div>

              <div className="btnFilter">
                <Button size="small" onClick={filtrarSelec}>
                  <FilterListIcon fontSize="small" className="Filter" />{" "}
                  Filtrar
                </Button>
              </div>
            </div>
          </div>

          {/* ================= LISTAS ================= */}
          <div className="contenedorColumnas">
            <div>
              <div className="columnaTablaIzq">
                <ul className="ulDisponibles">
                  {disponiblesFiltrados.map((item: any) => (
                    <li
                      key={item.id}
                      className="listaGruposSeleccionadas"
                    >
                      <div
                        className="botonListaSeleccionadas"
                        onClick={() => moverADerecha(item)}
                      >
                        <img
                          className="imagenCursor"
                          src="/assets/icons/icono-flecha-derecha.svg"
                          alt="RightRow"
                        />
                      </div>
                      <div>
                        <span className="textoGrupoSeleccionadas">
                          {item?.bussinesName}
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div id="payroll_3">
              <div className="botonIzquierda">
                <img
                  onClick={eliminaTodas}
                  className="imagenCursor"
                  src="/assets/icons/icono-flecha-izquierda.svg"
                  alt="eliminar"
                />
              </div>
              <div className="botonDerecha">
                <img
                  onClick={agregaTodas}
                  className="imagenCursor"
                  src="/assets/icons/icono-flecha-derecha.svg"
                  alt="agregar"
                />
              </div>
            </div>

            <div className="columnaTablaDer">
              <ul className="ulDisponibles">
                {seleccionadasFiltradas.map((item: any) => (
                  <li
                    key={item.id}
                    className="listaGruposDisponibles"
                  >
                    <div>
                      <span className="textoGrupoDisponibles">
                        {item.bussinesName}
                      </span>
                    </div>
                    <div
                      className="botonListaDisponibles"
                      onClick={() => moverAIzquierda(item)}
                    >
                      <img
                        className="imagenCursor"
                        src="/assets/icons/icono-flecha-izquierda.svg"
                        alt="leftRow"
                      />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* ================= BOTONES ================= */}
        <div className="containerButtons">
          <div className="containerCancelPreestacion">
            <button
              className="btnCancelPrestacion"
              type="button"
              onClick={cancelar}
            >
              Cancelar
            </button>
          </div>

          <div className="containerAddPrestacion">
            <button
              className="btnAddPrestacionColaborador"
              type="button"
              onClick={handleAddUser}
            >
              Aplicar
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AdminColaboradoresPrestacion;